import { render } from "./PopupHighlight.vue?vue&type=template&id=aba2f5aa&scoped=true"
import script from "./PopupHighlight.vue?vue&type=script&lang=js"
export * from "./PopupHighlight.vue?vue&type=script&lang=js"

import "./PopupHighlight.vue?vue&type=style&index=0&id=aba2f5aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba2f5aa"]])

export default __exports__